import type { ItemPhotoInputRole } from "@workspace/api-client-react";

export const MAX_ITEM_PHOTOS = 20;

export const PHOTO_ROLES: Array<{
  role: ItemPhotoInputRole;
  label: string;
  cardLabel?: string;
  shortLabel: string;
  maxRole: number;
}> = [
  {
    role: "blade_profile_left",
    label: "Blade Profile — Left Side",
    cardLabel: "Blade Profile\nLeft Side",
    shortLabel: "Blade Left",
    maxRole: 1,
  },
  {
    role: "blade_profile_right",
    label: "Blade Profile — Right Side",
    cardLabel: "Blade Profile\nRight Side",
    shortLabel: "Blade Right",
    maxRole: 1,
  },
  {
    role: "touchmark",
    label: "Touchmark",
    shortLabel: "Touchmark",
    maxRole: 3,
  },
  {
    role: "sheath_front",
    label: "Sheath — Front",
    cardLabel: "Sheath\nFront",
    shortLabel: "Sheath Front",
    maxRole: 1,
  },
  {
    role: "sheath_back",
    label: "Sheath — Back",
    cardLabel: "Sheath\nBack",
    shortLabel: "Sheath Back",
    maxRole: 1,
  },
  { role: "box", label: "Box", shortLabel: "Box", maxRole: 1 },
  {
    role: "paperwork",
    label: "Paperwork",
    shortLabel: "Paperwork",
    maxRole: 2,
  },
  { role: "misc", label: "Miscellaneous", shortLabel: "Misc", maxRole: 5 },
];

export function getPhotoRoleLabel(role: string, short = false): string {
  const photoRole = PHOTO_ROLES.find((entry) => entry.role === role);
  return photoRole ? (short ? photoRole.shortLabel : photoRole.label) : role;
}

export function getRoleAccept(role: string): string {
  return role === "paperwork" || role === "misc" ? "image/*,application/pdf" : "image/*";
}

export function roleAllowsPdf(role: string): boolean {
  return role === "paperwork" || role === "misc";
}

export function isImageAttachment(mediaType?: unknown): boolean {
  return mediaType === undefined ||
    (typeof mediaType === "string" && mediaType.toLowerCase().startsWith("image/"));
}
